
export default {
  props: {
    errors: Array,
  },
};
